import React, { createContext, useState } from "react";
import PropType from "prop-types";
import Cookies from "js-cookie";
import { gql, useMutation } from "@apollo/client";
import { isContentWriter } from "./PrivateRoutes/routingUtils";

export const AuthContext = createContext();

export const AuthProvider = (props) => {
  const [user, setUserState] = useState(
    JSON.parse(localStorage.getItem("loggedInUser"))
  );

  const [userLoggedIn, setUserLoggedIn] = useState(!!Cookies.get("loggedIn"));

  function getUser() {
    if (Cookies.get("loggedIn")) {
      return JSON.parse(localStorage.getItem("loggedInUser"));
    } else {
      logoutUser();
      return undefined;
    }
  }

  function flattenUser(user) {
    return { groups: user.groups.map((group) => group.name) };
  }

  function setUser(user) {
    setUserState(user);
    setUserLoggedIn(true);
    localStorage.setItem("loggedInUser", JSON.stringify(flattenUser(user)));
  }

  function logoutUser() {
    const LOGOUT_QUERY = gql`
      mutation {
        logoutSession {
          success
        }
      }
    `;

    const [logoutSession] = useMutation(LOGOUT_QUERY);

    logoutSession().then();

    localStorage.removeItem("loggedInUser");
    Cookies.remove("loggedIn");
    setUserState(null);
    setUserLoggedIn(false);
  }

  function userIsContentWriter() {
    const user = getUser();

    if (!user) {
      return false;
    }

    return isContentWriter(user.groups);
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        userLoggedIn,
        getUser,
        setUser,
        logoutUser,
        userIsContentWriter,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropType.node.isRequired,
};
